import { useState, useEffect, useRef, useCallback } from 'react';
import default_bg from '../../img/carousel_img.jpeg';
import carousel_bg_1 from '../../img/children_day_1080_colored.jpeg';

import carousel_bg_3_mobile from '../../img/children_day_photo_mobile.jpeg';
import LoadingOverlay from '../uiComponents/loading'; // Import the LoadingOverlay component
import '../../css/main.css'; // Make sure you include required styles

const Carousel = () => {
    const [images, setImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const [isSliding, setIsSliding] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // State to track loading status
    const currentRef = useRef(null);
    const nextRef = useRef(null);

    // Function to update images based on window size
    const updateImages = () => {
        if (window.innerWidth > 768) {
            // Desktop images
            setImages([default_bg, carousel_bg_1]);
        } else {
            // Mobile images
            setImages([default_bg, carousel_bg_3_mobile]);
        }
    };

    useEffect(() => {
        // Set initial images based on window size
        updateImages();

        // Add event listener for window resize
        window.addEventListener('resize', updateImages);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', updateImages);
    }, []);
    const handleImageCycle = useCallback((direction) => {
        if (isSliding) return;

        setIsSliding(true);

        if (!currentRef.current || !nextRef.current) {
            setIsSliding(false);
            return;
        }

        currentRef.current.style.transition = 'left 0.8s ease-in-out';
        nextRef.current.style.transition = 'left 0.8s ease-in-out';

        if (direction === 'forward') {
            currentRef.current.style.left = `-${window.innerWidth}px`;
            nextRef.current.style.left = `0px`;
        } else {
            setNextIndex(currentIndex - 1 < 0 ? images.length - 1 : currentIndex - 1);
            nextRef.current.style.transition = 'none';
            nextRef.current.style.left = `-${window.innerWidth}px`;
            void nextRef.current.offsetWidth; // Force reflow
            nextRef.current.style.transition = 'left 0.8s ease-in-out';
            nextRef.current.style.left = `0px`;
            currentRef.current.style.left = `${window.innerWidth}px`;
        }

        setTimeout(() => {
            if (direction === 'forward') {
                setCurrentIndex((prev) => (prev + 1) % images.length);
                setNextIndex((prev) => (prev + 1) % images.length);
            } else {
                setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
                setNextIndex((prev) => (prev + 1) % images.length);

            }
            if (nextRef.current && currentRef.current) {
                currentRef.current.style.transition = 'none';
                nextRef.current.style.transition = 'none';
                currentRef.current.style.left = '0px';
                nextRef.current.style.left = `${window.innerWidth}px`;
            }

            if (currentRef.current && nextRef.current) {
                currentRef.current.style.transition = 'none';
                nextRef.current.style.transition = 'none';
                currentRef.current.style.left = '0px';
                nextRef.current.style.left = `${window.innerWidth}px`;
            }
            setIsSliding(false);
        }, 800);
    }, [isSliding, currentIndex, images.length]);


    useEffect(() => {
        const interval = setInterval(() => {
            handleImageCycle('forward'); // Automatically cycle images every 2 seconds
        }, 2000);
        return () => clearInterval(interval);
    }, [handleImageCycle]);

    const handleImageLoad = () => {
        setIsLoading(false); // Set loading to false when the image is loaded
    };

    return (
        <section className="banner-area" id="home" style={{ overflow: 'hidden', position: 'relative' }}>
            {isLoading && <LoadingOverlay />}
            <div className="carousel-arrows">
                <i className="fa fa-chevron-left back" onClick={() => { handleImageCycle('backward') }}></i>
                <i className="fa fa-chevron-right front" onClick={() => { handleImageCycle('forward') }}></i>
            </div>
            <img
                ref={currentRef}
                className="header-img"
                src={images[currentIndex]}
                alt="Current Background"
                loading="lazy"
                onLoad={handleImageLoad} // Trigger when the image is loaded
                style={{
                    position: 'absolute',
                    top: 0,
                    left: '0px',
                    width: '100vw',
                    height: '100%',
                    zIndex: 1,
                    filter: 'brightness(50%)',
                }}
                draggable="false"
            />
            <img
                ref={nextRef}
                className="header-img"
                src={images[nextIndex]}
                alt="Next Background"
                loading="lazy"
                onLoad={handleImageLoad} // Trigger when the image is loaded
                style={{
                    position: 'absolute',
                    top: 0,
                    left: `${window.innerWidth}px`,
                    width: '100vw',
                    height: '100%',
                    zIndex: 2,
                    filter: 'brightness(50%)',
                }}
                draggable="false"
            />
            {!isLoading && <div className="container">
                <div className="row fullscreen d-flex align-items-center justify-content-start">
                    <div className="banner-content col-lg-7" >
                        <h6 className="text-white text-uppercase">Serve the Lord with gladness! - Psalm 100:2</h6>
                        <h1>Baptist Church Alkapoor <br /></h1>
                        <a href="#about" className="primary-btn text-uppercase">About</a>
                    </div>
                </div>
            </div>}
        </section>
    );
};

export default Carousel;